import axios from "axios";
import { BASE_URL } from "../../helper/base-url";

function authHeaders() {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return { Authorization: `Bearer ${userData?.token}` };
}

async function adminGet(path, params = {}) {
  try {
    return await axios.get(`${BASE_URL}${path}`, { headers: authHeaders(), params });
  } catch (error) {
    return error.response;
  }
}

async function adminPut(path, body = {}) {
  try {
    return await axios.put(`${BASE_URL}${path}`, body, { headers: authHeaders() });
  } catch (error) {
    return error.response;
  }
}

async function adminPost(path, body = {}) {
  try {
    return await axios.post(`${BASE_URL}${path}`, body, { headers: authHeaders() });
  } catch (error) {
    return error.response;
  }
}

async function adminPatch(path, body = {}) {
  try {
    return await axios.patch(`${BASE_URL}${path}`, body, { headers: authHeaders() });
  } catch (error) {
    return error.response;
  }
}

export const getAdminPlatformConfig = () => adminGet("admin-platform-config");
export const saveAdminPlatformConfig = (body) => adminPut("admin-platform-config", body);
export const getPlatformAnnouncement = () => axios.get(`${BASE_URL}platform-announcement`);
export const getPlatformStatus = () => axios.get(`${BASE_URL}platform-status`);

export const getAdminSubscribers = (page = 1, status) =>
  adminGet("admin-list-subscribers", {
    page,
    limit: 25,
    status: status || undefined,
  });

export const getAdminSubscriptionPlans = () => adminGet("admin-subscription-plans");

export const createAdminSubscriptionPlan = (body) =>
  adminPost("admin-subscription-plans", body);

export const updateAdminSubscriptionPlan = (id, body) =>
  adminPatch(`admin-subscription-plans/${id}`, body);

export const grantAdminSubscription = (body) => adminPost("admin-subscription-grant", body);

export const resolveAdminSubscriptionUser = (query) =>
  adminGet("admin-resolve-subscription-user", { q: query });
export const extendAdminSubscription = (body) => adminPost("admin-subscription-extend", body);
export const cancelAdminSubscription = (body) => adminPost("admin-subscription-cancel", body);

export const getAdminCoupons = (page = 1) => adminGet("admin-list-coupons", { page, limit: 25 });
export const createAdminCoupon = (body) => adminPost("admin-create-coupon", body);
export const updateAdminCoupon = (id, body) => adminPatch(`admin-coupons/${id}`, body);

export const getAdminAuditLogs = (page = 1, action) =>
  adminGet("admin-audit-logs", { page, limit: 30, action: action || undefined });

export const getAdminDashboardMetrics = ({ dateFrom, dateTo } = {}) =>
  adminGet("admin-dashboard-metrics", {
    date_from: dateFrom || undefined,
    date_to: dateTo || undefined,
  });

export const getAdminCourses = (page = 1, status) =>
  adminGet("admin-list-courses", { page, limit: 25, status: status || undefined });

export const getAdminContentTestimonials = (page = 1) =>
  adminGet("admin-content-testimonials", { page, limit: 50 });
export const updateAdminContentTestimonial = (id, body) =>
  adminPut(`admin-content-testimonials/${id}`, body);

export const getAdminContentPlatformFeatures = (page = 1) =>
  adminGet("admin-content-platform-features", { page, limit: 50 });
export const updateAdminContentPlatformFeature = (id, body) =>
  adminPut(`admin-content-platform-features/${id}`, body);

export const getAdminContentHowItWorks = (page = 1) =>
  adminGet("admin-content-how-it-works", { page, limit: 50 });
export const updateAdminContentHowItWorks = (id, body) =>
  adminPut(`admin-content-how-it-works/${id}`, body);

/** Escrow payout queue (admin-approved releases) */
export const getAdminEscrowPayouts = (page = 1) =>
  adminGet("admin-escrow-payouts", { page, limit: 25 });
export const approveAdminEscrowPayout = (paymentId, reason) =>
  adminPost("admin-escrow-payouts/approve", { payment_id: paymentId, reason });
export const holdAdminEscrowPayout = (paymentId, reason) =>
  adminPost("admin-escrow-payouts/hold", { payment_id: paymentId, reason });

